import React from 'react';

class Report extends React.Component {
    render() {
        return <div key={this.props.route.path}>{this.props.workspace}</div>;
    }
}

export default Report;
